import { __assign, __awaiter, __generator } from "tslib";
import { createCartExports } from './cart/exports.cart';
import { createCheckoutExports } from './checkout/exports.checkout';
import { createWishlistExports } from './wishlist/exports.wishlist';
import { createBackInStockExports } from './backInStock/exports.backInStock';
import { createSettingsExports } from './settings/exports.settings';
import { createPaymentsExports } from './payments/exports.payments';
import { createProductExports } from './product/exports.product';
import { createNavigateExports } from './navigate/exports.navigate';
export var createPartialOnlineStoresPublicApi = function (_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return ({
        product: createProductExports({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
        navigate: createNavigateExports({ context: context, origin: origin }),
        backInStock: createBackInStockExports({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
        settings: createSettingsExports({ context: context, origin: origin }),
        payments: createPaymentsExports({ context: context }),
        wishlist: createWishlistExports({ context: context }),
    });
};
export var createExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    var partialApi = createPartialOnlineStoresPublicApi({ context: context, origin: origin, isOnlineStoresViewerScript: true });
    return __assign(__assign({ cart: createCartExports({ context: context }), checkout: createCheckoutExports({ context: context }) }, partialApi), { settings: __assign(__assign({}, partialApi.settings), { getOnlineStoresSettings: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, context.onlineStoresPropertiesService.getOnlineStoresSettings()];
            }); }); } }) });
};
//# sourceMappingURL=createExports.js.map